import React from "react";
import { ContentHeader } from "../../../../components/structure/ContentHeader";
import { Button } from "../../../../components/buttons/Button";

interface Props {
    onMakeDraft: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function EmptyProfile({ onMakeDraft }: Props) {
    return (
        <>
            <div className={"flex justify-between"}>
                <ContentHeader>Ingen Skabelon tilgængelig</ContentHeader>
                <div className={"flex gap-8"}>
                    <Button
                        onClick={(e) => onMakeDraft(e)}
                        theme={"secondary"}
                        size={"s"}
                    >
                        Opret ny kladde
                    </Button>
                </div>
            </div>
        </>
    );
}
